import { useEffect, useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { LetterTable } from './LetterTable';
import { lettersAPI } from '../../lib/lettersAPI';

const STATS = [['created_this_month', 'Created this month'], ['drafts', 'Drafts'], ['awaiting_approval', 'Awaiting approval'],
  ['requiring_signature', 'Requiring signature'], ['issued', 'Issued'], ['clearance_awaiting_response', 'Clearance awaiting response'],
  ['overdue_follow_ups', 'Overdue clearance follow-ups']];

export const LettersDashboard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { lettersAPI.dashboard().then(setS).catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7" data-testid="letters-stats">
        {STATS.map(([k, l]) => (
          <Card key={k}><CardContent className="p-4"><p className="text-2xl font-bold" data-testid={`letters-stat-${k}`}>{s ? s[k] : '–'}</p><p className="text-xs text-muted-foreground">{l}</p></CardContent></Card>))}
      </div>
      <div><p className="mb-2 text-sm font-medium">Recent letters</p><LetterTable status="" /></div>
    </div>
  );
};
